
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action } from "vuex-class"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import { caseColumns } from "@/types/caseColumns"
import UserImage from "@/components/UserImage.vue"
import { CaseDetails, CalculationType } from "@/types"

import { get } from "lodash"
import TimeSpentDisplay from "../CaseDetails/TimeSpentDisplay.vue"

@Component({
	components: {
		"user-image": UserImage,
		"scrollbar": VuePerfectScrollbar,
		"time-spent-display": TimeSpentDisplay
	}
})
export default class CaseFieldDisplay extends Vue {
	@Prop()
	caseDetails!: any;

	@Prop()
	fields!: any[];

	@Prop()
	sectionHeader!: string;

	CalculationType = CalculationType
}

